// Phase 6 — Track D T-D2. useDailyDeck hook.

import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import type { DailyDeck } from '@dailydeck/shared/types';
import { apiClient } from '../app/apiClient.js';

export const DAILY_DECK_QUERY_KEY = ['daily-deck'] as const;

export function useDailyDeck(): UseQueryResult<DailyDeck, Error> {
  return useQuery<DailyDeck, Error>({
    queryKey: DAILY_DECK_QUERY_KEY,
    queryFn: () => apiClient.dailyDeck.today(),
  });
}
